import { useState } from "react";
import "../styles/Filters.css";
import Input from "./input";

const TextFilterDropdown = ({
  filterName,
  columnName = "Search",
  searchFilters,
  setSearchFilters,
  closeFilter,
  alignRight = false,
  setWrapperRef,
}) => {
  const currentFilter = searchFilters?.[filterName];
  const initialValue = currentFilter?.value || "";
  const [inputValue, setInputValue] = useState(initialValue);

  const handleApply = () => {
    const trimmed = String(inputValue || "").trim();
    if (!trimmed) {
      setSearchFilters((prev = {}) => {
        const updated = { ...prev };
        delete updated[filterName];
        return updated;
      });
      if (closeFilter) closeFilter();
      return;
    }

    setSearchFilters((prev = {}) => ({
      ...prev,
      [filterName]: {
        filter_type: "contains",
        value: trimmed,
      },
    }));

    if (closeFilter) closeFilter();
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleApply();
    }
  };

  return (
    <div
      className={`filter_wrapper${alignRight ? " filter_wrapper_align_right" : ""}`}
      ref={setWrapperRef}
      style={{ minWidth: "200px" }}
    >
      <div className="d-flex flex-column gap-2" onKeyDown={handleKeyDown}>
        <Input
          label={columnName || "Search Text"}
          placeholder={`Search ${columnName || "text"}`}
          type="text"
          name={filterName}
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          required={false}
        />
      </div>

      <div className="filter_buttons mt-2">
        <button type="button" onClick={closeFilter} className="btn-cancel">
          Cancel
        </button>
        <button
          type="button"
          onClick={handleApply}
          className="btn-apply"
        >
          Apply
        </button>
      </div>
    </div>
  );
};

export default TextFilterDropdown;
